"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const navIcons_1 = require("./navIcons");
const iconByName = (name) => (icon) => {
    const [, iconName] = icon.iconLight;
    return iconName === name;
};
exports.default = (name) => navIcons_1.icons.find(iconByName(name));
//# sourceMappingURL=findIcon.js.map